"use client"

import styled, { css } from "styled-components"

import { Paragraph as BaseParagraph } from "@/components/Paragraph"

export const Body = styled.div`
  ${({ theme }) => {
    const { colors } = theme

    return css`
      color: ${colors.fg};
      background-color: ${colors.bg};
      margin: 0;
      padding: 0;
      display: block;
      width: 100%;
      height: auto;
      min-height: 100vh;
    `
  }}
`
export const Card = styled.section`
  ${({ theme }) => {
    const { borders, colors, spaces } = theme

    return css`
      background-color: ${colors.content.bg};
      border-radius: ${borders.radius.standard};
      padding: ${spaces.large};
    `
  }}
`
export const H2 = styled.h2`
  ${({ theme }) => {
    const { fonts } = theme

    return css`
      margin: 0;
      font-size: ${fonts.size.heading3};
      text-transform: uppercase;
      font-weight: ${fonts.weight.regular};
      text-align: center;
    `
  }}
`

export const Footer = styled.footer`
  ${({ theme }) => {
    const { spaces } = theme

    return css`
      display: flex;
      justify-content: space-between;
      margin-top: ${spaces.large};
    `
  }}
`
export const Paragraph = styled(BaseParagraph)`
  white-space: break-spaces;
`

export const ErrorCard = styled.section`
  ${({ theme }) => {
    const { borders, colors, spaces } = theme

    return css`
      background-color: ${colors.content.bg};
      border-radius: ${borders.radius.standard};
      padding: ${spaces.large};
      margin-top: 4rem;
    `
  }}
`
export const ErrorBox = styled.main`
  margin: 0 auto;
  width: 100%;
  max-width: 25rem;
  height: 100%;
`
